// extracted by mini-css-extract-plugin
export default {"container":"date_container__uhiv7","message":"date_message__6XhY0","line":"date_line__deMf8"};